export const AFTER_INACTIVITY_SCROLL_TARGET = 'AFTER_INACTIVITY_SCROLL_TARGET';
export const INACTIVITY_TIMEOUT = 3_600_000;
